import React from "react";
import AppStreamState from "./AppStreamState";

const AppStreamConnectionState = ({ appstream_connection_state }) => (
    <>
        {appstream_connection_state == 'CONNECTED' &&
            <small className="text-success">Connected</small>}
        {appstream_connection_state == 'NOT_CONNECTED' &&
            <small className="text-danger">Not Connected</small>}
    </>
);

export default AppStreamConnectionState;